import Upsertable from '@/models/Upsertable'
import { useAgriSubContractStore } from '@/stores/agriSubContractStore'
import Field from './Field'
import Customer from '@/models/Customer.js'
import { reactive, toRaw } from 'vue'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class AgriSubContract extends Upsertable {
  static store() {
    return useAgriSubContractStore()
  }

  static from(rawObject) {
    return Object.assign(new AgriSubContract(), toRaw(rawObject))
  }

  store() {
    return AgriSubContract.store()
  }

  field() {
    if (this._field) return this._field

    let field = Object.assign(new Field(), { uuid: this.field_uuid })
    this._field = reactive(field)

    Field.store().getRecord(this.field_uuid).then((rawRecord) => {
      field = Object.assign(new Field(), toRaw(rawRecord))
      Object.assign(this._field, field)
    })

    return this._field
  }

  static findAllActiveContractsByFieldUuid(fieldUuid) {
    const activeStatuses = ['technical_phase_one', 'technical_phase_two', 'technical_phase_three'];
    return AgriSubContract.store()
      .all()
      .filter(c => c.field_uuid === fieldUuid && activeStatuses.includes(c.status));
  }


  customer() {
    if (this._customer) return this._customer
    
    let customer = Object.assign(new Customer(), { uuid: this.customer_uuid })
    this._customer = reactive(customer)

    Customer.store().getRecord(this.customer_uuid).then((rawRecord) => {
      customer = Object.assign(new Customer(), toRaw(rawRecord))
      Object.assign(this._customer, customer)
    })

    return this._customer
  }
}

useModelName(AgriSubContract, "AgriSubContract")
ModelRegistry.register(AgriSubContract, "AgriSubContract")